import { render, staticRenderFns } from "./attachment-list.vue?vue&type=template&id=de617f5a&scoped=true&"
import script from "./attachment-list.vue?vue&type=script&lang=js&"
export * from "./attachment-list.vue?vue&type=script&lang=js&"
import style0 from "./attachment-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./attachment-list.vue?vue&type=style&index=1&id=de617f5a&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "de617f5a",
  null
  
)

export default component.exports